export default __webpack_public_path__ + "static/media/Page_11.310d79bd.png";